import { render, staticRenderFns } from "./ReportsGenderGap.vue?vue&type=template&id=37fb5c64&scoped=true&"
import script from "./ReportsGenderGap.vue?vue&type=script&lang=js&"
export * from "./ReportsGenderGap.vue?vue&type=script&lang=js&"
import style1 from "./ReportsGenderGap.vue?vue&type=style&index=1&id=37fb5c64&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fb5c64",
  null
  
)

export default component.exports